import { useTranslation } from 'react-i18next';

import { applyLocale, getActiveLocales, type SupportedLocale } from '../../i18n';
import styles from './LanguageSwitcher.module.css';

const LOCALE_LABELS: Record<SupportedLocale, string> = {
  ru: 'RU',
  en: 'EN',
  be: 'BE',
  de: 'DE',
};

// PARA-105, AC-7: переключатель языка в шапке — [RU|EN|BE|DE▾].
// PARA-122 (D5, AC-5): сегмент-пилюля дизайн-системы вместо нативного <select>
// PARA-138: активный список уже ограничен per-user пересечением в AuthProvider.
// (образец: etc/design-system/project/components/navigation/LanguageSwitcher.jsx).
// Доступность: контейнер role="radiogroup", сегменты role="radio" + aria-checked;
// авто-ширина (немецкие подписи не обрезаются). Каретка ▾ на последнем сегменте —
// декоративная (aria-hidden), доступное имя остаётся чистым ("DE").
export function LanguageSwitcher(): JSX.Element {
  const { i18n } = useTranslation();
  const current = i18n.language as SupportedLocale;
  const activeLocales = getActiveLocales();
  const selected = activeLocales.includes(current) ? current : 'en';

  return (
    <div className={styles.track} role="radiogroup" aria-label="language">
      {activeLocales.map((locale, index) => {
        const active = locale === selected;
        const isLast = index === activeLocales.length - 1;
        return (
          <button
            key={locale}
            type="button"
            role="radio"
            aria-checked={active}
            className={[styles.segment, active ? styles.active : ''].filter(Boolean).join(' ')}
            onClick={() => applyLocale(locale, true)}
          >
            {LOCALE_LABELS[locale]}
            {isLast && (
              <span className={styles.caret} aria-hidden="true">
                {' ▾'}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
